import { Component} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlatformService } from './classes/services/platform.service';
import { AuthService } from './shared/auth/auth.service';
import { NavigationEnd,Router } from '@angular/router';

declare global {
  interface Window { _paq: any[]; }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  trade = false;
  lottieConfig = {
    width: '50vw',
    height: 'auto',
    path: './assets/lottie/loader.json',
  };
  private routeStatus: NavigationEnd;
  static loaderSubject = new BehaviorSubject(false);
  static isBrowser = new BehaviorSubject<boolean>(false);
  constructor(
    private platform: PlatformService,
    private auth: AuthService,
    private _router: Router,
  ) {
  }
  async ngOnInit() {
    if (this.platform.isPlatformBrowser()) {
      AppComponent.isBrowser.next(true);
      this._router.events.subscribe({
        next: (it) => {
          if (it instanceof NavigationEnd) this.routeStatus = it;
        },
      });
    }

    if (AppComponent.isBrowser.value) {

      this.auth
        .checkValidToken()
        .then((res) => {
          if (res[0]) {
            this.auth.rememberUser(res[1]);
          } else {
            this.auth.logOutUser();
          }
        })
        .catch((error) => {
          console.error('Error checking valid token:', error);
        });
    }

    // Matomo Code
    if (this.platform.isPlatformBrowser()) {
      AppComponent.isBrowser.next(true);
  
      // اولین بازدید
      if (window._paq) {
        window._paq.push(['setCustomUrl', window.location.pathname]);
        window._paq.push(['trackPageView']);
      }
  
      // بعد از هر تغییر مسیر
      this._router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (window._paq) {
            window._paq.push(['setCustomUrl', event.urlAfterRedirects]);
            window._paq.push(['trackPageView']);
          }
        }
      });
    }
  }
  get httpLoader() {
    return AppComponent.loaderSubject.value;
  }
  get _platformValue() {
    return AppComponent.isBrowser.value;
  }
  static changeMainBg(type: 'white' | 'creamy') {
    if (AppComponent.isBrowser.value) {
      let main = document.body.getElementsByTagName('main')[0];

      let mainClass = main.classList;

      if (type == 'creamy') {
        mainClass.remove('bg-white');
        main.className = `${mainClass} bg-[#FAFAFA]`;
      } else {
        mainClass.remove('bg-[#FAFAFA]');
        main.className = `${mainClass} bg-white`;
      }
    }
  }
}
